var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "exam" }, [_vm._v(" exam ")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }